import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import store from '@/store'
import { Entry, Level } from '@/modules/log';

export default class Log {

    public static consoleLog = true

    public static readonly consoleLevels: KeyValuePair = {
        [Level.Info]: 'info',
        [Level.Error]: 'error',
    }

    /**
     * Registra un evento con nivel de depuración
     *
     * @param message
     * @param context
     */
    public static debug (message: string, context: KeyValuePair = {}) {
        this.log(Level.Debug, message, context)
    }

    /**
     * Registra un evento con nivel de información
     *
     * @param message
     * @param context
     */
    public static info (message: string, context: KeyValuePair = {}) {
       this.log(Level.Info, message, context)
    }

    public static error (message: string, context: KeyValuePair = {}) {
        this.log(Level.Error, message, context)
    }

    protected static log (level: Level, message: string, context: KeyValuePair) {
        const entry = new Entry(level, message, context)
        store.commit('log/entry/add', entry)

        // Si esta activada esta opción se enviará el log a la consola del navegador
        if (this.consoleLog) {
            const consoleMessage = `[LOG.${entry.level.toUpperCase()}]: ${entry.message}`
            _.invoke(console, this.consoleLevels[entry.level] || 'log', consoleMessage, entry)
        }

        return entry
    }
}

